import { Device } from '@peloton/browser/identify';

export enum App {
  IOS = 'IOS',
  Android = 'Android',
  FireTV = 'FireTV',
  AppleTV = 'AppleTV',
  AndroidTV = 'AndroidTV',
  Roku = 'Roku',
}

const map = {
  [Device.IOS]: App.IOS,
  [Device.Android]: App.Android,
};

// @ts-expect-error (TS7053): Element implicitly has an 'any' type because expression of type 'Device' can't be used to index type '{ IOS: App; Android: App; }'.
export const toApp = (device: Device) => map[device];
